import React, { useEffect,useState } from "react";
import {
  Button,
  Divider,
  TextField,
  Typography,
  Paper,
  Grid,
  InputAdornment,
  IconButton,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import GoogleIcon from "@mui/icons-material/Google";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import register from "../../../assets/images/home-page-images/Register.png";
import logoHeader from "assets/images/home-page-images/TavloAI.png";
import {Link, NavLink,useNavigate } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import MailIcon from "@mui/icons-material/Mail";
import HttpsIcon from "@mui/icons-material/Https";
import { googleLoginUserAsync, loginUserAsync, resendVerifyEmailAsync } from "../../../features/actions/auth";
import { useDispatch, useSelector } from "react-redux";
import MDButton from "components/MDButton";
import { useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-hot-toast";
import MDInput from "components/MDInput";
import showHideIcon from "assets/images/small-logos/show-hide-icon.svg";
import dontShowIcon from "assets/images/small-logos/dont-show.svg";
import icon from "assets/images/google.png";
import Loader from "assets/loader/loader";
import LockOpenIcon from '@mui/icons-material/LockOpen';
const Login = () => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  // const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};
    if (!formData.name.trim()) tempErrors.name = "Name is required";
    if (!formData.email.trim()) {
      tempErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      tempErrors.email = "Enter a valid email address";
    }
    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" }); // clear error on typing
  };

  // const handleSubmit = (e) => {
  //   e.preventDefault(); // prevent page refresh
  //   if (validate()) {
  //     console.log("Form Data:", formData);
  //   }
  // };



 const dispatch = useDispatch();
  const navigate = useNavigate();
  const [submit, setSubmit] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { loginData, resendVerifyEmail } = useSelector((state) => state.auth);
  const [showVerify, setShowVerify] = useState(false);
  const token = localStorage.getItem("token");
  const [values, setValues] = useState({
    username: "",
    password: "",

    // keepMeLogin: false,
  });

  const [errors, setErrors] = useState({
    username: "",
    password: "",
    // keepMeLogin: "",
  });
  const eyeButton = () => {
    setShowPassword(!showPassword);
  };
  const login = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      try {
        setLoading(true);
        await dispatch(googleLoginUserAsync(tokenResponse.access_token));
        navigate("/dashboard");
      } catch (error) {
        console.log(error);
      }
    },
    onNonOAuthError: () => {
      setLoading(false);
    },
    onError: (error) => {
      setLoading(false);
      console.log(error);
    },
  });
  const validateForm = (formData) => {
    const errors = {};

    // Trim and validate values
    const trimmedUsername = formData?.username?.trim();
    const trimmedPassword = formData?.password?.trim();
    const checkEmail = /^\S+@\S+\.\S+$/; // Email without leading and trailing spaces

    // Validate email
    if (!trimmedUsername) {
      errors.username = "Email is required";
    } else if (!checkEmail.test(trimmedUsername)) {
      errors.username = "Invalid email format";
    }
    if (!trimmedPassword) {
      errors.password = "Password is required.";
    }

    return errors;
  };

  useEffect(() => {
    if (loginData?.data?.status_code == 200 || token) {
      if (
        loginData?.data?.restaurant_details?.length == 0 &&
        loginData?.data?.onboarding_status?.[0]?.true_count == 0
      ) {
        navigate("/my-business");
      } else if (
        loginData?.data?.restaurant_details?.length > 0 &&
        loginData?.data?.onboarding_status?.[0]?.true_count != 0
      ) {
        const firstOnboardedRestaurant =
          loginData?.data?.restaurant_details.find(
            (restaurant) => restaurant.onboarding_status === "true"
          );

        if (firstOnboardedRestaurant) {
          localStorage.setItem("common_id", firstOnboardedRestaurant.common_id);
          localStorage.setItem(
            "business_name",
            firstOnboardedRestaurant.restaurant_name
          );
        }

        navigate("/dashboard");
      }
    }
  }, [loginData?.data, token]);

  useEffect(() => {
    if (
      loginData?.detail?.message ==
      "Please verify your account, check the registered email for verification link."
    ) {
      setShowVerify(true);
    }
  }, [loginData]);

  useEffect(() => {
    if (resendVerifyEmail?.status_code == 200) {
    }
  }, [resendVerifyEmail]);

  const inputHandler = (fieldName) => {
    return (e) => {
      setValues({ ...values, [fieldName]: e.target.value });
    };
  };

  const handleSubmit = async () => {
    const errors = validateForm(values);
    console.log("Form Data:", errors);
    if (Object.keys(errors).length === 0) {
      setLoading(true);
      const formDataObject = new FormData();
      // Append trimmed and validated values to formDataObject
      Object.keys(values).forEach((key) => {
        formDataObject.append(key, values[key].trim());
      });

      await dispatch(loginUserAsync(formDataObject));
      try {
        setLoading(false);
      } catch (error) {
        setLoading(false);
      } finally {
        setSubmit(false);
      }
    } else {
      setErrors(errors);
      setSubmit(true); // This will trigger displaying errors if any
    }
  };

  const verifyEmailButton = () => {
    if (values.username) {
      let payload = {
        email: values.username,
      };
      dispatch(resendVerifyEmailAsync(payload));
    } else {
      toast.error("Email is required");
    }
  };


  return (
    <>
    {loading && <Loader />}
    <MDBox
      sx={{
        position: "relative",
        width: "100%",
        maxWidth: {
          xs: "100%",
          md: "1580px",
          xl: "1920px",
        },
        mx: "auto",
        // px: 2,
      }}
    >
        {/* {showVerify ? (
        <>
         <MDTypography color="error" fontWeight="medium" mt={1}>
           Please verify your account, check the registered email
           for verification link. if you don't have received any
           verification email then click here to
           <span
             className="resend-verify"
             fontWeight="medium"
             onClick={verifyEmailButton}
           >
             {" "}
             Resend verify email
           </span>
          </MDTypography>
          <MDTypography
            variant="button"
            color="info"
            fontWeight="medium"
            textGradient
           ></MDTypography>
        </>
      ) : (
        ""
      )} */}

      <Grid container sx={{ marginleft: "10px" }}>
        <Grid
          item
          md={6}
          px={0}
          sx={{
            py: 1.5,
            px: 2,
            display: "flex",
            justifyContent: "space-between",
            "@media(max-width:400px)": { px: 0, py: 2 },
          }}
        >
          <MDBox
            sx={{
              display: "flex",
              justifyContent: "space-between",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <MDBox sx={{ width: "100%", textAlign: "start" }}>
              <MDBox
                sx={{
                  zIndex: "4",
                  width: "120px",

                  "@media (min-width:768px)": { width: "190px" },
                }}
              >
                <NavLink to="/">
                  <MDBox
                    component="img"
                    src={logoHeader}
                    alt="background"
                    sx={{
                      width: {
                        xs: "117px",
                        sm: "95%",
                        md: "100%",
                      },

                      height: {
                        xs: "26px",
                        sm: "657px",
                        md: "auto",
                      },
                      ml: {
                        xs: 2,
                        sm: 0,
                        md: 0,
                      },
                    }}
                  />
                </NavLink>
              </MDBox>
            </MDBox>
          </MDBox>
        </Grid>
      </Grid>

      <MDBox
        sx={{
          maxHeight: "700px",
          height: {
            xs: "700px",
            sm: "100vh",
            md: "87.7vh",
          },
          width: "100vw",
          backgroundImage: `url(${register})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {/* Form Card */}
        <Paper
          elevation={4}
          sx={{
            position: "relative",
            mx: {
              xs: 4,
              sm: 2,
              md: 0,
            },
            zIndex: 1,
            px: {
              xs: 4,
              sm: 7,
              md: 7,
            },
            py: 2,
            borderRadius: "10px",
            backdropFilter: "blur(10px)",
            border: "2px solid #777777ff",

            // borderImageSource:
            //   "linear-gradient(135deg, rgba(255, 255, 255, 0.4) 0%, rgba(255, 255, 255, 0.08) 50%)",
            // borderImageSlice: 1,
            maxWidth: 400,
            width: "100%",
            backgroundColor: "rgba(100, 100, 100, 0.3)",
          }}
        >
          <MDTypography
            align="center"
            gutterBottom
            sx={{
              color: "#fff",
              fontFamily: "Poppins",
              fontWeight: 600,
              fontSize: "32px",
            }}
          >
            Login
          </MDTypography>

          <MDBox component="form" noValidate sx={{}}>
            <TextField
              fullWidth
              name="email"
              label="Email"
              id="standard-basic"
              variant="standard"
              margin="dense"
              value={values.username}
              onChange={inputHandler("username")}
              error={!!errors.username}
              helperText={errors.username}
              autoComplete="off"
              sx={{
                mt: 0,
                mb: 1,
                "& .MuiInputLabel-root": {
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 600,
                  transform: "translate(0, 30px) scale(1)",
                },
                "& .MuiInputLabel-shrink": {
                  transform: "translate(0, 4px) scale(0.85)",
                  color: "#fff !important", 
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#fff !important", 
                },
                "& .MuiInputBase-root": {
                  fontSize: "12px",
                  color: "#fff",
                  "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 1000px transparent inset",
                    WebkitTextFillColor: "#fff",
                    transition: "background-color 5000s ease-in-out 0s",
                  },
                },
                "& imput " :{
                    fontSize:"12px",
                    transition:"background-color 50000s ease-in-out 0s",
                    color:"#ffff"

                }
              }}
              InputProps={{
                style: { fontSize: 15, color: "#fff" },
                endAdornment: (
                  <InputAdornment position="end">
                    <MailIcon sx={{ color: "white" }} htmlColor="white" />
                  </InputAdornment>
                ),
              }}
            />
            <TextField
              fullWidth
              name="password"
              label="Password"
              id="standard-basic"
              variant="standard"
              margin="dense"
              type={showPassword ? "text" : "password"}
              value={values.password}
              onChange={inputHandler("password")}
              error={!!errors.password}
              helperText={errors.password}
              autoComplete="off"
              sx={{
                mt: 0,
                mb: 2,
                "& .MuiInputLabel-root": {
                  color: "#fff",
                  fontFamily: "Poppins",
                  fontSize: "12px",
                  fontWeight: 600,
                  transform: "translate(0, 30px) scale(1)",
                },
                "& .MuiInputLabel-shrink": {
                  transform: "translate(0, 4px) scale(0.85)",
                  color: "#fff !important", 
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#fff !important", 
                },
                "& .MuiInputBase-root": {
                  fontSize: "12px",
                  color: "#fff",
                  "&:-webkit-autofill": {
                    WebkitBoxShadow: "0 0 0 1000px transparent inset",
                    WebkitTextFillColor: "#fff",
                    transition: "background-color 5000s ease-in-out 0s",
                  },
                },
              }}
              
              InputProps={{
                style: { fontSize: 15, color: "#fff" },
                endAdornment: (
                   <IconButton
               onClick={() => eyeButton()}
              edge="end"
              sx={{ color: "white" }}
            >
              {showPassword ? <LockOpenIcon   sx={{ color: "#ffff", fontSize: 22 }}/> : <HttpsIcon sx={{ color: "#ffff", fontSize: 22 }}/>}
            </IconButton>
                ),
              }}
            />

            <MDBox
              sx={{
                height:"20px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
                mb:1
              }}
            >
              {/* Check Button */}
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      color: "#fff",
                      transform: "scale(0.6)",
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                        mt:1,
                      },
                    }}
                  />
                }
                label="Remember me"
                sx={{
                  color: "#fff",
                  "& .MuiTypography-root": {
                    color: "#fff",
                    fontSize: "10px",
                    fontFamily: "Poppins",
                    marginLeft: -1,
                  },
                }}
              />

              {/* Forgot Button */}
              <MDTypography
                component={NavLink}
                to="/forget-password"
                variant="text"
                sx={{
                  textTransform: "none",
                  color: "#fff",
                  fontSize: "11px",
                  fontWeight: 600,
                  fontFamily: "Poppins",
                  cursor: "pointer",
                }}
              >
                Forgot Password?
              </MDTypography>
            </MDBox>

            <MDBox>
             <MDButton
               variant="gradient"
                sx={{
                cursor: "Pointer",
                width: "100%",
                border: "none",
                mt: 0.5,
                textAlign: "center",
                fontSize: "12px",
                fontFamily: "Poppins",
                color: "#000",
                backgroundColor: "#fff",
                textTransform: "capitalize",
                fontWeight: 600,
                py: 1,
                borderRadius: "6px",
                 "&:hover": {
                  background: "#fff",
                  },
                 }}
                 onClick={handleSubmit}
                 fullWidth
                 
                 >
                  Continue
                </MDButton>
              </MDBox>
                    
            <MDBox
              sx={{
                textAlign: "center",
                fontSize: "10px",
                // textTransform: "uppercase",
                my: 1,
                fontFamily: "Poppins",
                fontWeight: 600,
                color: "#fff",
              }}
            >
              OR
            </MDBox>


            <MDButton
             onClick={() => {
              setLoading(true);
              login();
              }}
                sx={{
                background:
                  "linear-gradient(90deg, #DB4437 0%, #F4B400 30%, #0F9D58 60%, #4285F4 100%)",
                cursor: "Pointer",
                width: "100%",
                border: "none",
                textAlign: "center",
                fontSize: "12px",
                fontFamily: "Poppins",
                color: "#fff",
                backgroundColor: "#fff",
                textTransform: "capitalize",
                fontWeight: 600,
                py: 1,
                borderRadius: "6px",
              }}
              >
              &nbsp; Continue with Google
            </MDButton>
          </MDBox>

          <MDTypography
            variant="body2"
            align="center"
            sx={{
              mt: 3,
              color: "text.secondary",
              color: "#fff",
              fontSize: "10px",
              fontFamily: "Poppins",
            }}
          >
            Don’t have an account?{" "}
            {/* <NavLink to="/register" style={{ textDecoration: "none" }}> */}
              <MDTypography
               component={Link}
                 to="/sign-up"
                sx={{
                  display: "inline",
                  cursor: "pointer",
                  color: "#fff",
                  fontWeight: 600,
                  fontSize: "12px",
                  fontFamily: "Poppins",
                  "&:hover": { textDecoration: "underline" },
                }}
              >
                Register
              </MDTypography>
            {/* </NavLink> */}
          </MDTypography>
        </Paper>
      </MDBox>
    </MDBox> 
    </>
  );
};

export default Login;
